/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : RouteProject.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import { useLocation } from "react-router-dom";
import ViewProjectConfig from "./NavigateProject/ViewProjectConfig";
import ProjectConfig from "./NavigateProject/ProjectConfig";
import CommonBreadcrumbs from "../../components/customComponentsV2/common/Breadcrumbs/CommonBreadcrumbs";

function RouteProject() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const projectId = queryParams.get("project_id");
  return (
    <div>
      {/* <CommonBreadcrumbs items={breadcrumbItems} /> */}
      {projectId ? <ViewProjectConfig /> : <ProjectConfig />}
    </div>
  );
}

export default RouteProject;
const breadcrumbItems = [
  { label: "Home", onClick: () => console.log("Go to Home") },
  { label: "Dashboard", onClick: () => console.log("Go to Dashboard") },
  { label: "Reports" },
];
